import React from 'react';

/**
 * Marks an unpublished assistant: only sysadmins can open it, so only they
 * ever see this (a draft, or a platform-internal assistant).
 */
const UnpublishedBadge: React.FC = () => (
    <span
        className="badge text-bg-warning fw-normal"
        title="Unpublished: only sysadmins can see and use this assistant"
    >
        unpublished
    </span>
);

export default UnpublishedBadge;
